export const BILLING_TYPE = {
  PAY_NOW: "PAY_NOW",
  CONTRA_COD: "CONTRA_COD",
};

export const BILLING_TYPE_LABELS = {
  [BILLING_TYPE.PAY_NOW]: "Type 1 - Pay Now",
  [BILLING_TYPE.CONTRA_COD]: "Type 2 - Contra with COD",
};

export const CREDIT_TERMS = [14, 30, 45, 60];

export const DEFAULT_CREDIT_TERM = 14;
